import { decodeBase64ToUint8Array } from "./supportTicketAttachmentDecode";

export function triggerAttachmentDownload(contentBase64: string, fileType: string, fileName: string): void {
  const raw = decodeBase64ToUint8Array(contentBase64);
  const blob = new Blob([Uint8Array.from(raw)], { type: fileType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = "noopener";
  anchor.click();
  URL.revokeObjectURL(url);
}
